import type { SVGProps } from 'react';
export const SelectAll = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.35 4.35v11.3h11.3V4.35zM3 4.25C3 3.56 3.56 3 4.25 3h11.5c.69 0 1.25.56 1.25 1.25v11.5c0 .69-.56 1.25-1.25 1.25H4.25C3.56 17 3 16.44 3 15.75zm10.65 3.56c.26.27.25.7-.02.96L9.4 12.79a.7.7 0 0 1-.93 0l-2.1-2.01a.68.68 0 1 1 .93-.98l1.63 1.56L12.7 7.8c.27-.26.7-.25.96.02"
      clipRule="evenodd"
    />
  </svg>
);
